














import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { Toast } from 'vant';
@Component({
  components: {},
})
export default class Leave extends Vue {
  experience: string = '';
  onConfirm(value: string) {}
  onSubmit(values: any) {
    console.log('submit', values);
  }
  onClickLeft() {
    this.$router.go(-1);
  }
}
